module.exports = __webpack_public_path__ + "static/media/autochilango-noneOption.ccce64fd.svg";